// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app h4[data-v-0d96ff7a]{font-weight:700;font-size:1em;margin-bottom:1.5em}#app .border-bottom[data-v-0d96ff7a]{padding-bottom:1em;margin-bottom:1em;border-bottom:.1em solid #a0a0a0}#app select[data-v-0d96ff7a]{margin-top:1.4em}#app .checkbox[data-v-0d96ff7a]{margin-top:1.5rem;padding:1rem;background-color:#f8f8f8}#app img[data-v-0d96ff7a]{display:block;width:5em;height:5em;border-radius:5em;border:.1rem solid #777;margin-bottom:.5em}", ""]);
// Exports
module.exports = exports;
